import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useApiToken } from './useApiToken'
import { inventoryApi } from '../lib/api/inventory'

export const INVENTORY_KEY = ['inventory'] as const

export function useInventory() {
  const getToken = useApiToken()
  return useQuery({
    queryKey: INVENTORY_KEY,
    queryFn: async () => {
      const token = await getToken()
      return inventoryApi.list(token)
    },
  })
}

export function useSetTrialOverride() {
  const getToken = useApiToken()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ capacityId, tenantId, overrideDate }: { capacityId: string; tenantId: string; overrideDate: string | null }) => {
      const token = await getToken()
      return inventoryApi.setTrialOverride(token, capacityId, tenantId, overrideDate)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: INVENTORY_KEY }),
    onError: (e: Error) => toast.error('Failed to save override: ' + e.message),
  })
}
